import { configureStore } from '@reduxjs/toolkit';
import validationResultsReducer from './validation/validationResultsSlice';
import configReducer from './app/configSlice';
import getDevicesSliceReducer from './devices/getDevicesSlice';
import editDevicesSliceReducer from './devices/editDevicesSlice';
import createDevicesSliceReducer from './devices/createDevicesSlice';
import deleteDevicesSliceReducer from './devices/deleteDevicesSlice';
import getFlowsSliceReducer from './flows/getFlowsSlice';
import createFlowSliceReducer from './flows/createFlowSlice';
import updateFlowSliceReducer from './flows/updateFlowSlice';
import createEventSliceReducer from './flows/createEventSlice';
import updateEventSliceReducer from './flows/updateEventSlice';
import deleteAttributeSliceReducer from './flows/deleteAttributeSlice';
import deleteScenarioSliceReducer from './flows/deleteScenarioSlice';
import deleteEventSliceReducer from './flows/deleteEventSlice';
import deleteFlowSliceReducer from './flows/deleteFlowSlice';
import saveRegressionResultsReducer from './regressionResults/saveRegressionResultsSlice';
import testHistoryReducer from './testHistory/testHistorySlice';
import getRegressionTestIdsReducer from './regressionTestIds/getRegressionTestIdsSlice';
import confluenceJobsReducer from './confluence/confluenceJobsSlice';
import bugReportReducer from './bugReport/bugReportSlice';
import platformReducer from './app/platformSlice';
import regressionCrudReducer from './regressionTestIds/regressionCrudSlice';
import locatorDriftReducer from './locatorDrift/locatorDriftSlice';
import runSummaryReducer from './runSummary/runSummarySlice';
import searchLocatorsReducer from './locatorManagement/searchLocatorsSlice';
import updateLocatorReducer from './locatorManagement/updateLocatorSlice';
import createLocatorReducer from './locatorManagement/createLocatorSlice';
import marketsReducer from './markets/getMarketsSlice';
import schemasReducer from './flows/schemasSlice';
import eventFailureTicketsReducer from './eventFailureTickets/eventFailureTicketsSlice';

export default configureStore({
  reducer: {
    validationResults: validationResultsReducer,
    config: configReducer,
    getDevices: getDevicesSliceReducer,
    editDevices: editDevicesSliceReducer,
    createDevices: createDevicesSliceReducer,
    deleteDevices: deleteDevicesSliceReducer,
    getFlows: getFlowsSliceReducer,
    createTestFlow: createFlowSliceReducer,
    updateTestFlow: updateFlowSliceReducer,
    createTestEvent: createEventSliceReducer,
    updateTestEvent: updateEventSliceReducer,
    deleteAttribute: deleteAttributeSliceReducer,
    deleteScenario: deleteScenarioSliceReducer,
    deleteEvent: deleteEventSliceReducer,
    deleteFlow: deleteFlowSliceReducer,
    saveRegressionResults: saveRegressionResultsReducer,
    testHistory: testHistoryReducer,
    getRegressionTestIds: getRegressionTestIdsReducer,
    confluenceJobs: confluenceJobsReducer,
    bugReport: bugReportReducer,
    platform: platformReducer,
    regressionCrud: regressionCrudReducer,
    locatorDrift: locatorDriftReducer,
    runSummary: runSummaryReducer,
    searchLocators: searchLocatorsReducer,
    updateLocator: updateLocatorReducer,
    createLocator: createLocatorReducer,
    markets: marketsReducer,
    schemas: schemasReducer,
    eventFailureTickets: eventFailureTicketsReducer,
  },
});
